<script setup lang="ts">
defineProps<{
  title: string;
  hint?: string;
}>();
</script>

<template>
  <div class="admin-page-header">
    <div class="title-wrap">
      <h2>{{ title }}</h2>
      <p v-if="hint" class="hint">{{ hint }}</p>
    </div>
    <div v-if="$slots.default" class="actions">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.admin-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.title-wrap h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--gyjk-text-primary, #1a2b25);
}
.hint {
  margin: 4px 0 0;
  color: var(--gyjk-text-secondary, #718078);
  font-size: 13px;
}
.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
</style>
